import { gql, useQuery } from '@apollo/client';

function useYouMayAlsoNeed({ sizeId, slug }) {
  const getSlug = () => {
    if ([18].includes(sizeId)) {
      return `supreme-felted-rug-pad-10-x-14-32070`;
    }
    if ([25, 47, 26, 24, 23].includes(sizeId)) {
      return `supreme-felted-rug-pad-3-x-5-32067`;
    }

    if ([48, 49, 30, 35, 42, 43, 45, 32, 56].includes(sizeId)) {
      return `supreme-felted-rug-pad-6-x-9-32068`;
    }

    if ([37, 36, 39, 40, 44].includes(sizeId)) {
      return `supreme-felted-rug-pad-8-x-10-32069`;
    }
  };

  if (!slug) {
    slug = getSlug();
  }

  const { loading, error, data } = useQuery(PRODUCT_BY_SLUG, {
    variables: {
      slug: slug
    },
    skip: !slug,
    fetchPolicy: 'network-only'
  });

  return { loading, error, data };
}

export default useYouMayAlsoNeed;

export const PRODUCT_BY_SLUG = gql`
  query productBySlug($slug: String!) {
    productBySlug(slug: $slug) {
      id
      slug
      sku
      name
      price
      full_price
      lead_time
      shipping_window
      care
      is_purchasable
      is_assembled
      bestReview {
        id
        user {
          id
          first_name
          last_name
        }
        rating
        title
        message
      }
      supplier {
        id
      }
      fabric {
        id
        is_available_on_pdp
        name
        image
        image_width
        image_height
        description
        colors {
          id
          name
        }
        material {
          id
          name
          care
          description
          durability
          composition
          image
        }
        collaborator {
          id
          name
        }
        pattern {
          id
          name
        }
      }
      images {
        id
        name
        path
        width
        height
      }
      availableSizes {
        id
        is_available_on_pdp
        name
      }
      leg {
        id
        name
      }
      casterLeg {
        id
        name
      }
      frame {
        id
        name
        slug
        frame_materials
        is_final_sale
        has_assembly_options
        weight
        weight_limit
        assembly_instructions
        country_of_origin
        compliance
        ship_method
        box_spring
        box_dimensions
        orientation
        dimensions
        dimensions_image
        dimensions_image_width
        dimensions_image_height
        additional_details
        pillowscaping_icon
        primarySubcategory {
          id
          category_id
          name
        }
        pillowscapingFrames {
          id
          slug
        }
        shippingServices {
          id
          name
          price
        }
        subcategories {
          id
          name
          avg_rating
          total_reviews
          category {
            id
            name
            slug
          }
        }
        lifestyles {
          id
          image
          width
          height
        }
        size {
          id
          is_available_on_pdp
          name
        }
        legs {
          id
          name
          image
        }
        casterLegs {
          id
          name
          image
        }
      }
    }
  }
`;
